<template>
  <div class="app-edit-general">
    <validation-observer
      ref="main_form"
      v-slot="{ validated }"
    >
      <b-row>
        <b-col
          cols="6"
          style="padding-right: 4.714rem;padding-left: 2rem;"
        >
          <b-row style="margin-bottom: 1.714rem">
            <b-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                :name="$t('apps.appName')"
                vid="app name"
                :rules="{ required: true }"
              >
                <label for="input-app-name">{{ $t('apps.appName') }}</label>
                <b-input
                  id="input-app-name"
                  v-model="app_name"
                />
                <small
                  v-if="validated && errors.length > 0"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                :name="$t('apps.appUrl')"
                vid="app url"
                :rules="{required: true, url: true}"
              >
                <label for="input-app-url">{{ $t('apps.appUrl') }}</label>
                <b-input
                  id="input-app-url"
                  v-model="app_url"
                  name="app_url"
                />
                <small
                  v-if="validated && errors.length > 0"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6">
          <b-row class="mb-1">
            <b-col
              cols="12"
              style="display:flex;"
            >
              <div style="display: inline-block; margin-right: 1.571rem;">
                <label>{{ $t('apps.status') }}</label>
              </div>
              <div
                v-if="isLiveMode"
                class="app-status"
              >
                <div>
                  <b-badge variant="light-success">
                    {{ $t('apps.live') }}
                  </b-badge>
                </div>
                <div style="clear: both" />
                <small>
                  {{ $t('apps.yourAppIsLive') }}
                </small>
              </div>
              <div
                v-if="isTestMode"
                class="app-status"
              >
                <div style="width: 100%; clear: both;">
                  <b-badge variant="light-warning">
                    {{ $t('apps.test') }}
                  </b-badge>
                </div>
                <div style="clear:both" />
                <div style="padding-top: 0.357rem;">
                  <b-button
                    id="go-live-btn-small"
                    :variant="btnGoliveVariant"
                    size="sm"
                    @click="requestToMakeAppLive()"
                  >
                    {{ $t('apps.requestToGoLive') }}
                  </b-button>
                  <b-tooltip
                    v-if="btnGoliveVariant === 'secondary'"
                    target="go-live-btn-small"
                    placement="bottom"
                    triggers="hover"
                  >
                    {{ $t('apps.pleaseCompleteTheAppSetupFirst') }}
                  </b-tooltip>
                </div>
                <div
                  style="font-weight: 500; font-size: 0.857rem; line-height: 1.143rem; color: #6E6B7B; padding-top: 0.5rem;"
                >
                  {{ $t('apps.beforeAnAppGoesLiveForTheFirstTime') }}<br>
                  {{ $t('apps.reviewTheIntegrationToMakeSureThe') }}<br>
                  {{ $t('apps.setupIsWorkingCorrectly') }}
                </div>
              </div>
              <div
                v-if="isInApproval"
                class="app-status"
              >
                <div>
                  <b-badge variant="light-primary">
                    {{ $t('apps.inApproval') }}
                  </b-badge>
                </div>
                <div style="clear:both" />
                <div
                  style="font-weight: 500; font-size: 0.857rem; line-height: 1.143rem; color: #6E6B7B; padding-top: 0.5rem;"
                >
                  {{ $t('apps.weAreCurrentlyCheckingYourIntegrationWeWillGet') }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="isLiveMode"
            class="mb-1"
          >
            <b-col cols="3">
              <div style="clear:both;">
                {{ $t('apps.testMode') }}
              </div>
              <small>{{ $t('apps.showsYouDummySurveysToTestYourIntegrationYour') }}</small>
            </b-col>
            <b-col cols="9">
              <div
                class="form-inline"
                style="height: 2.857rem;"
              >
                <b-form-checkbox
                  v-model="test_mode"
                  switch
                  class="mr-1"
                />
              </div>

              <div v-if="test_mode">
                <div>
                  <div
                    v-for="(item, index) in test_mode_value"
                    :key="index"
                    class="d-flex align-items-center mb-2 gap-2"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-radio
                        v-model="item.type"
                        value="ip"
                        :name="`test_mode_type_${index}`"
                      >
                        {{ $t('apps.ip') }}
                      </b-form-radio>
                      <b-form-radio
                        v-model="item.type"
                        value="user"
                        :name="`test_mode_type_${index}`"
                        class="ml-1"
                      >
                        {{ $t('apps.user') }}
                      </b-form-radio>
                    </div>

                    <b-input-group class="flex-grow-1 ml-1 align-items-center">
                      <b-form-input
                        v-model="item.value"
                        :placeholder="$t('apps.enterValue')"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="danger"
                          class="d-flex align-items-center"
                          style="height: 100%;"
                          @click="test_mode_value.splice(index, 1)"
                        >
                          <feather-icon
                            icon="MinusCircleIcon"
                            style="margin-right: 5px;"
                          />
                          <span class="d-inline-block">{{ $t('apps.remove') }}</span>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>

                  <b-button
                    variant="success"
                    class="mt-2"
                    @click="test_mode_value.push({ type: '', value: '' })"
                  >
                    <feather-icon
                      icon="PlusCircleIcon"
                      style="margin-right: 5px;"
                    />
                    {{ $t('apps.add') }}
                  </b-button>

                  <div>
                    <small
                      v-if="showTestModeError"
                      class="text-danger"
                    >
                      {{ $t('apps.atLeastOneIpOrUserMustBeAdded') }}
                    </small>
                  </div>
                </div>
              </div>

            </b-col>
          </b-row>
          <b-row
            v-if="isLiveMode"
            class="mb-1"
          >
            <b-col cols="3">
              <div style="clear:both;">
                {{ $t('apps.securityHash') }}
              </div>
              <small>{{ $t('apps.enablesDisablesSecurityHashForAppIntegration') }}</small>
            </b-col>
            <b-col cols="9">
              <div
                class="form-inline"
                style="height: 2.857rem;"
              >
                <b-form-checkbox
                  v-model="is_secure"
                  switch
                  class="mr-1"
                  disabled
                />
              </div>

              <template v-if="is_secure">
                <div class="code-copy-block">
                  <div
                    class="button-copy bg-primary"
                    @click="copyText(security_hash_salt)"
                  >
                    <span>{{ $t('apps.copy') }}</span>
                  </div>
                  <div class="code-content bg-light-primary">
                    <pre class="code-block">
                      <span style="color: rgb(136, 0, 0);">{{ security_hash_salt }}</span>
                    </pre>
                  </div>
                </div>
              </template>
              <template v-else>
                <b-badge variant="light-warning">
                  {{ $t('apps.contactYourAccountManagerToEnableSecurityHashing') }}
                </b-badge>
              </template>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!--        <b-row>
                  <b-col style="text-align: right;">
                          <b-button
                          variant="outline-secondary"
                          @click="reset_data"
                          >Reset</b-button
                      >
                  </b-col>
              </b-row>-->
    </validation-observer>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'

extend('url', {
  validate(value) {
    return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value)
  },
  message: (field, parameters) => i18n.t('apps.thisValueMustBeAValidUrl', { ...parameters, _field_: field }),
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: ['value'],
  data() {
    return {
      app_name: '',
      app_url: '',
      test_mode: false,
      test_mode_value: [],
      status: 0,
      mounted: false,
      is_secure: false,
      showTestModeError: false,
      security_hash_salt: null,
    }
  },
  computed: {
    disabledLiveMode() {
      return parseInt(this.value.status) !== 1
    },
    watchParentValue() {
      return [
        this.value.app_name,
        this.value.app_url,
        this.value.status,
        this.value.test_mode,
        this.value.test_mode_value,
        this.value.is_secure,
        this.value.security_hash_salt,
      ]
    },
    isLiveMode() {
      return parseInt(this.value.status) === 1
    },
    isTestMode() {
      return parseInt(this.value.status) === 0
    },
    isInApproval() {
      return parseInt(this.value.status) === 2
    },
    btnGoliveVariant() {
      let isValidReward = false
      if (this.value.reward_type !== 0) isValidReward = true
      else if (this.value.fixed_reward) isValidReward = true
      if (this.value.currency_exchange_rate && this.value.currency_name && isValidReward) return 'primary'
      return 'secondary'
    },
  },
  watch: {
    app_name: 'syncToParent',
    app_url: 'syncToParent',
    status: 'syncToParent',
    test_mode_value: {
      handler: 'syncToParent',
      deep: true,
    },
    is_secure: 'syncToParent',
    test_mode(newVal) {
      // Keep existing logic
      this.syncToParent(newVal)

      // Add default row if needed
      if (newVal && (!Array.isArray(this.test_mode_value) || this.test_mode_value.length === 0)) {
        this.test_mode_value = [{
          type: '',
          value: '',
        }]
      }
    },
    watchParentValue() {
      this.init_data()
    },
  },
  mounted() {
    this.init_data()
    this.mounted = true
  },
  methods: {
    reset_data() {
      this.$emit('reset', [
        'app_name',
        'app_url',
        'test_mode',
        'status',
        'test_mode_value',
      ])
    },
    init_data() {
      this.app_name = this.value.app_name
      this.app_url = this.value.app_url
      this.status = this.value.status
      this.test_mode = this.value.test_mode
      this.test_mode_value = this.value.test_mode_value
      this.is_secure = this.value.is_secure
      this.security_hash_salt = this.value.security_hash_salt
    },
    requestToMakeAppLive() {
      if (this.btnGoliveVariant === 'secondary') return Promise.resolve(false)

      this.showLoading()

      return this.$http
        .post(`/api/app/${this.$route.params.appHash}/request-live`)
        .then(response => {
          if (response.data.status) {
            this.$emit('request-live', response.data.status)
          }
          return true // Ensure we return a value in every case
        })
        .catch(errors => {
          this.alertApiError(errors, i18n.t('apps.requestToGoLiveFailed'))
          return false // Ensure we return a value in every case
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    validateTestModeValue() {
      if (!this.test_mode) {
        this.showTestModeError = false
        return true
      }

      const isValid = Array.isArray(this.test_mode_value)
        && this.test_mode_value.some(
          item => item.type?.trim?.() && item.value?.trim?.(),
        )

      this.showTestModeError = !isValid
      return isValid
    },
    syncToParent() {
      if (!this.mounted) return

      const appData = this.value
      appData.app_name = this.app_name
      appData.app_url = this.app_url
      appData.status = this.status
      appData.test_mode = this.test_mode
      appData.test_mode_value = this.test_mode_value
      appData.is_secure = this.is_secure
      appData.security_hash_salt = this.security_hash_salt
      this.$emit('input', appData)
    },
  },
}
</script>
<style scoped lang="scss">
.app-status {
  display: inline-block;
}

.app-edit-general {

  label {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 100%;
    color: #5E5873;
    margin-bottom: 0.857rem;
  }

  .code-copy-block {
    position: relative;
    background: rgba(115, 103, 240, 0.12);
    border-radius: 0.429rem;
    overflow: hidden;

    & > .button-copy {
      width: 5.571rem;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      color: #FFF;
      text-align: center;
      cursor: pointer;

      span {
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
      }
    }

    & > .code-content {
      flex: 1;
      padding: 0.714rem;
      padding-left: 6.286rem;
    }
  }

  .code-block {
    display: block;
    white-space: initial;
    background: none;
    font-size: 1rem;
    margin-bottom: 0;
  }

}

.app-edit-general .code-copy-block > .code-content > pre > span {
  display: inline !important;
}
</style>
